import React from 'react'
import { NavLink } from 'react-router-dom'

export default function Admin() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        padding: 16,
        maxWidth: 400,
      }}
    >
      <ul>
        <li>
          <NavLink to="ghost">Ghost Login</NavLink>
        </li>
        <li>
          <NavLink to="transfer">Transfer Card</NavLink>
        </li>
        <li>
          <NavLink to="custom">Move to CUSTOM subscription</NavLink>
        </li>
        <li>
          <NavLink to="trial">Add trial days</NavLink>
        </li>
      </ul>
    </div>
  )
}
